module.exports = __webpack_public_path__ + "static/face_01-441752878f40a7b5f24cbf0cce3e9adf.jpg";